<h5 mat-dialog-title appLocalizationPopupDirective localizationCode="Integrations-Mappings">{{ 'Integrations-Mappings' | translate: {Default: "Integration Mapping"} }}</h5>

<mat-dialog-content>
    <ng-container *ngIf="!loadingFields && !loadingTables; else loading">
        <form class="form" [formGroup]="form">

            <mat-form-field appLocalizationPopupDirective localizationCode="Integrations-HubbubHRTable" appearance="fill">
                <mat-label>{{ 'Integrations-HubbubHRTable' | translate: {Default: "Hubbub Table"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="table" (valueChange)="handleSelectTableClick($event)" class="mat-form-field">
                    <mat-optgroup *ngFor="let group of tableGroups" [label]="group.groupName">
                        <mat-option *ngFor="let table of group.tables" [value]="table.id">
                            {{table.name}}
                        </mat-option>
                    </mat-optgroup>
                </mat-select>
            </mat-form-field>

            <mat-form-field appLocalizationPopupDirective localizationCode="Integrations-HubbubHRField" appearance="fill" *ngIf="selectedTable != null">
                <mat-label>{{ 'Integrations-HubbubHRField' | translate: {Default: "Hubbub Field"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="tableField">
                    <app-select-search [search]="tableFieldSearch"></app-select-search>
                    <mat-option *ngFor="let field of tableFieldSearch.options" [value]="field.id">
                        {{field.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="lookup-option" *ngIf="isLookupField">
                <mat-slide-toggle setColor="primaryColour" formControlName="createLookupIfMissing" appLocalizationPopupDirective localizationCode="ImportCreateLookupIfMissing">
                    {{ 'ImportCreateLookupIfMissing' | translate: {Default: "Create Lookup If Missing"} }}
                </mat-slide-toggle>
                <p class="field-hint" appLocalizationPopupDirective localizationCode="Adp-CreateLookupIfMissingHint">
                    {{ 'Adp-CreateLookupIfMissingHint' | translate: {Default: "The value from Adp (after any transformation below) is matched to the text of an option in this lookup. If there is no match, turn this on to add it as a new option instead of skipping it."} }}
                </p>
            </div>

            <mat-form-field appLocalizationPopupDirective localizationCode="Adp-Field" appearance="fill">
                <mat-label>{{ 'Adp-Field' | translate: {Default: "Adp Field"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="integrationFieldId">
                    <app-select-search [search]="adpFieldSearch"></app-select-search>
                    <mat-option *ngFor="let field of adpFieldSearch.options" [value]="field">
                        {{field}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <p class="field-hint" appLocalizationPopupDirective localizationCode="Adp-WorkAssignmentsHint">
                {{ 'Adp-WorkAssignmentsHint' | translate: {Default: "WorkAssignments.* fields resolve against the worker's primary work assignment. Other lists, such as emails, use the first entry that has a value. Organizational units can also be picked by position, e.g. HomeOrganizationalUnits[1]."} }}
            </p>

            <div class="form-section">
                <div class="form-section-title">
                    <h6 appLocalizationPopupDirective localizationCode="Adp-Transformations">{{ 'Adp-Transformations' | translate: {Default: "Transformations"} }}</h6>

                    <button appLocalizationPopupDirective localizationCode="Adp-AddTransformation" mat-stroked-button class="add-localization-btn" setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="addTransformation()">
                        <mat-icon class="material-icons-outlined">add</mat-icon>
                        {{ 'Adp-AddTransformation' | translate: {Default: "Add Transformation"} }}
                    </button>
                </div>
                <div class="form-section-contents">
                    <div class="section-row">
                        <div formArrayName="transformations">
                            <div *ngFor="let transformation of form.controls.transformations.controls; let i=index" [formGroupName]="i" class="transformation-group">
                                <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="Hubbub-Value">
                                    <mat-label>{{ 'Hubbub-Value' | translate: {Default: "Hubbub Value"} }}</mat-label>
                                    <input matInput formControlName="hubbub">
                                </mat-form-field>
                                <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="Adp-Value">
                                    <mat-label>{{ 'Adp-Value' | translate: {Default: "Adp Value"} }}</mat-label>
                                    <input matInput formControlName="integrationTarget">
                                </mat-form-field>
                                <mat-icon
                                    setColor
                                    [setColorRules]="[
                                        {
                                            color: 'primaryColour',
                                            events: ['hover']
                                        }
                                    ]"
                                    class="material-icons-outlined clickable-icon"
                                    appPreventDoubleClick (throttledClick)="removeTransformation(i)"
                                    matTooltip="Delete"
                                >delete</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>

    <ng-template #loading>
        <mat-dialog-content class="loading">
            <ngx-skeleton-loader
            count="5"
            [theme]="{
                'height.px': 50
            }"
            ></ngx-skeleton-loader>
        </mat-dialog-content>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>
